import { Ellipsis } from '@zoom/components';
import React from 'react';
import { DropdownItem } from 'reactstrap';

export type OptionProps<T = number | string> = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  active?: boolean;
  onClick: (value: T, event: React.MouseEvent<HTMLElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  tabIndex?: number;
  value: T;
} & React.PropsWithChildren;

export const TimePickerOption: React.FC<OptionProps> = ({
  active = false,
  children,
  className,
  onClick = () => null,
  onKeyDown,
  tabIndex,
  value,
}) => (
  <DropdownItem
    className={className}
    onClick={(event) => onClick(value, event)}
    active={active}
    toggle={false}
    value={value}
    tabIndex={tabIndex}
    onKeyDown={onKeyDown}
    {...{
      tabindex: tabIndex,
    }}
  >
    <span className="time-picker-option">
      {/* @ts-expect-error: Incompatible type of FC from React < v18 */}
      <Ellipsis>{children}</Ellipsis>
    </span>
  </DropdownItem>
);
